import React from 'react'
import NoticeIcon from 'images/icons/notice-icon.inline.svg'
import { noticeIcon } from './notice-styles.module.scss';
 

const Notice = () => {
    return ( 
        <div style={{marginTop: '2em'}}>     
            <p><NoticeIcon className={noticeIcon}/> Looking for the current docs? <a href="https://doc.lucidworks.com/" target="_blank" rel="noreferrer"><span className="underline">Check out the main documentation here</span></a></p>
        </div> 
    )
}

export default Notice